import { Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { PROJECT_TYPE } from './constants';
import { LanguageConfigDTO, ModuleHeaderData, PageItem, UnifiedModuleDto } from './header-interfaces';
import { MenuItem } from 'primeng/api';
import { Observable } from 'rxjs';

@Component({
    selector: 'lib-module-header',
    templateUrl: './module-header.component.html',
    styleUrls: ['./module-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModuleHeaderComponent implements OnInit {

    public contactLink = 'https://govforms.gov.il/mw/forms/mashov@Antiquities.gov.il';
    public declinedLink = 'https://atikot.sharepoint.com/sites/Portal/SitePages/%D7%9E%D7%A1%D7%9E%D7%9B%D7%99%D7%9D-%D7%90%D7%A8%D7%92%D7%95%D7%A0%D7%99%D7%99%D7%9D(1).aspx';
    public modelsLinkHe = 'https://experience.arcgis.com/experience/08c0ac0049044d1d8a86044545c152d0?locale=he';
    public modelsLinkEn = 'https://experience.arcgis.com/experience/fe0c17b263fc4641b684a559c0571944';
    public tutorialVideosPlaylist = 'https://www.youtube.com/playlist?list=PLudCzAmVjuKynwW11Llq5XPQDbsxPfxEX';
    // public videoUrl = 'assets/video/login-video.mp4';
    isDropdownOpen = false;
    isUserMenuOpen = false;
    isVideoModalOpen = false;
    currentUserMenuIndex = -1;
    currentLanguageIndex = -1; // -1 = no selection, 0 = Hebrew, 1 = English
  
    environment = '';
    tabMenuItems: MenuItem[] = [];
    activeTab!: MenuItem;
    _moduleDetails: UnifiedModuleDto[] | undefined;
    hoveredMenuId = -1;
    focusedMenuId = -1;
    hoveredContact = false;
    hoveredDeclined = false;
    hoveredModels = false;
    hoveredTutorialVideo = false;
    hoveredUser = false;
    hoveredLanguage = false;


    @Input() projectType!: PROJECT_TYPE;
    @Input() pages: PageItem[] = [];
    @Input() infoPages: PageItem[] = [];
    @Input() userName!: string;
    @Input() isAuthenticated!: boolean;
    @Input() isInternalUser = false;
    @Input() activePage!: PageItem;
    @Output() onLogoClick = new EventEmitter();
    @Output() onLangChange = new EventEmitter();


    @Input() set moduleDetails(details: UnifiedModuleDto[]) {
        console.log('moduleDetails', details);
        this._moduleDetails = details;
        this.tabMenuItems = details.map((module) => {
            return {
                label: module.title,
                tabLabel: module.tabLabel || module.title,
                icon: 'data:image/svg+xml;base64,'.concat(module.icons?.active),
                id: module.name
            }
        }) || [];
        const activeItemId = details.find((module) => module.isActive)?.name;
        this.activeTab = this.tabMenuItems.find(item => item.id === activeItemId) || this.tabMenuItems[0];
    }

    @Input () moduleHeaderData: ModuleHeaderData | undefined;
    @Input () userMenuItemsUnified: any;
    @Input() languageConfig!: Observable<LanguageConfigDTO>;

    @Output() onLogout = new EventEmitter();
    @Output() onLogin = new EventEmitter();
    @Output() onPageChange = new EventEmitter();

    isInfoExpanded = false;
    userMenuItems = [
        {
            label: 'התנתק ',
            icon: 'pi pi-sign-out',
            command: this.logout.bind(this),
        },
    ];

    constructor(private location: Location) {

    }
    setHoverLanguage(value: boolean) {
        this.hoveredLanguage = value;
      }
    setHoverUser(value: boolean) {
        this.hoveredUser = value;
      }
    toggleDropdown(): void {
        this.isDropdownOpen = !this.isDropdownOpen;
      }
      
      closeDropdown(): void {
        this.isDropdownOpen = false;
        this.currentLanguageIndex = -1;
      }
      
      selectLanguage(lang: string): void {
        // Call your existing langChange() method or replicate its logic
        this.langChange(); // or your specific language switching logic
        
        this.closeDropdown();
      }
    ngOnInit(): void {
        this.initConfig();
        const pageId = new URLSearchParams(window.location.search).get('pageId');
        if(window.opener !== null){
            this.isInfoExpanded = this.infoPages.some((page: PageItem) => page.id.toString() === pageId);
            if (this.isInfoExpanded) {
                setTimeout(() => {
                    const selected = document.querySelector('#info-pages-menu > .selected');
                    if (selected instanceof HTMLElement) {
                        selected.focus();
                    }
                }, 500);
            }
        }
    }
    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent): void {
      const target = event.target as HTMLElement;
      const dropdown = target.closest('.language-dropdown');
      const userMenu = target.closest('.user-menu-container');
      
      if (!dropdown) {
        this.closeDropdown();
      }
      
      if (!userMenu) {
        this.closeUserMenu();
      }
    }
    
    @HostListener('document:keydown', ['$event'])
    onDocumentKeydown(event: KeyboardEvent): void {
      if (event.key === 'Escape' && this.isVideoModalOpen) {
        this.closeVideoModal();
        event.preventDefault();
      }
    }
    toggleInfoExpansionClick(event: any) {
        this.isInfoExpanded = !this.isInfoExpanded;
        event.preventDefault();
        if (this.isInfoExpanded) {
            setTimeout(() => {
                const selected = document.querySelector('#info-pages-menu > .selected');
                if (selected instanceof HTMLElement) {
                    selected.focus();
                }
            }, 0);
        }

    }

    toggleInfoExpansion(event: any) {
        if (event.key === 'Enter' || event.key === ' ') {
            this.isInfoExpanded = !this.isInfoExpanded;
            event.preventDefault();
        } else if (event.key === 'Escape') {
            this.isInfoExpanded = false;
            event.preventDefault();
        }
        if (this.isInfoExpanded) {
            setTimeout(() => {
                const selected = document.querySelector('#info-pages-menu > .selected');
                if (selected instanceof HTMLElement) {
                    selected.focus();
                }
            }, 0);
        }
    }

    closeExpansion(event: any) {
        if (event.key === 'Escape') {
            this.isInfoExpanded = false;
            event.preventDefault();
            document.getElementById('info-pages-menu-button')?.focus();
        }
    }

    setHoverExpansion(id: number) {
        this.hoveredMenuId = id;
    }

    setFocusExpansion(id: number) {
        this.focusedMenuId = id;
    }


    getInActiveIcon(id: string) {
        const inActiveIcon = this._moduleDetails?.find((a) => a.name === id)?.icons.inactive || '';
        return 'data:image/svg+xml;base64,'.concat(inActiveIcon);
    }

    capitalizeFirstLetter(string: string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    initConfig() {
        const environments = ['dev', 'test', 'prod'];
        this.environment = environments.find((env) => window.location.origin.includes(env)) || '';
    }

    logout() {
        this.onLogout.emit();
    }

    handlePageChange(id: number) {
        this.isInfoExpanded = false;
        document.getElementById('info-pages-menu-button')?.focus();
        this.onPageChange.emit(id);
    }

    goBack() {
        this.location.back();
    }
    goNext() {
        this.location.forward();
    }

    onTabClick($event: MenuItem) {
        const url = this._moduleDetails?.find(
            (module) => module.name === $event.id
        )?.url;
        if (url) {
            window.location.href = url;
        }
    }

    logoClick() {
        this.onLogoClick.emit();
    }
    langChange() {
        this.onLangChange.emit();
    }
    setHoverContact(isHover: boolean) {
        this.hoveredContact = isHover;
    }
    setHoverDeclined(isHover: boolean) {
        this.hoveredDeclined = isHover;
    }
    setHoverModels(isHover: boolean) {
        this.hoveredModels = isHover;
    }
    contactUs() {
        window.open(this.contactLink, '_blank');
    }
    openModels() {
        const link = this.moduleHeaderData?.isEnglish ? this.modelsLinkEn : this.modelsLinkHe;
        window.open(link, '_blank');
    }
    setHoverTutorialVideo(isHover: boolean) {
        this.hoveredTutorialVideo = isHover;
    }
    openTutorialVideo() {
        const link = this.tutorialVideosPlaylist;
        window.open(link, '_blank');
    }
    declined() {
        window.open(this.declinedLink, '_blank');
    }

    handleLanguageKeydown(event: KeyboardEvent): void {
        const languageOptions = ['he', 'en']; // Hebrew = 0, English = 1
        
        switch (event.key) {
          case 'ArrowDown':
            event.preventDefault();
            if (!this.isDropdownOpen) {
              this.isDropdownOpen = true;
              this.currentLanguageIndex = 0; // Start with Hebrew
            } else {
              this.currentLanguageIndex = (this.currentLanguageIndex + 1) % languageOptions.length;
            }
            break;
          case 'ArrowUp':
            event.preventDefault();
            if (!this.isDropdownOpen) {
              this.isDropdownOpen = true;
              this.currentLanguageIndex = languageOptions.length - 1; // Start with English
            } else {
              this.currentLanguageIndex = this.currentLanguageIndex <= 0 ? languageOptions.length - 1 : this.currentLanguageIndex - 1;
            }
            break;
          case 'Enter':
            event.preventDefault();
            if (!this.isDropdownOpen) {
              this.isDropdownOpen = true;
              this.currentLanguageIndex = this.moduleHeaderData?.isEnglish ? 1 : 0; // Current language
            } else if (this.currentLanguageIndex >= 0) {
              // Select the currently focused language
              this.selectLanguage(languageOptions[this.currentLanguageIndex]);
            }
            break;
          case 'Escape':
            event.preventDefault();
            this.closeDropdown();
            break;
          case ' ':
            event.preventDefault();
            this.toggleDropdown();
            if (this.isDropdownOpen) {
              this.currentLanguageIndex = this.moduleHeaderData?.isEnglish ? 1 : 0; // Current language
            }
            break;
        }
      }

      toggleUserMenu(): void {
        this.isUserMenuOpen = !this.isUserMenuOpen;
      }
      
      closeUserMenu(): void {
        this.isUserMenuOpen = false;
        this.currentUserMenuIndex = -1;
      }
      
      handleUserMenuKeydown(event: KeyboardEvent): void {
        const menuItems = this.userMenuItemsUnified || this.userMenuItems;
        if (!menuItems) return;
        
        switch (event.key) {
          case 'ArrowDown':
            event.preventDefault();
            if (!this.isUserMenuOpen) {
              this.isUserMenuOpen = true;
              this.currentUserMenuIndex = 0;
            } else {
              this.currentUserMenuIndex = (this.currentUserMenuIndex + 1) % menuItems.length;
            }
            break;
          case 'ArrowUp':
            event.preventDefault();
            if (!this.isUserMenuOpen) {
              this.isUserMenuOpen = true;
              this.currentUserMenuIndex = menuItems.length - 1;
            } else {
              this.currentUserMenuIndex = this.currentUserMenuIndex <= 0 ? menuItems.length - 1 : this.currentUserMenuIndex - 1;
            }
            break;
          case 'Enter':
            event.preventDefault();
            if (!this.isUserMenuOpen) {
              this.isUserMenuOpen = true;
              this.currentUserMenuIndex = 0;
            } else if (this.currentUserMenuIndex >= 0 && menuItems[this.currentUserMenuIndex]) {
              const item = menuItems[this.currentUserMenuIndex];
              if (item.command) {
                item.command();
              }
              this.closeUserMenu();
            }
            break;
          case 'Escape':
            event.preventDefault();
            this.closeUserMenu();
            break;
          case ' ':
            event.preventDefault();
            this.toggleUserMenu();
            break;
        }
      }

    openVideoModal() {
        this.isVideoModalOpen = true;
    }
    
    closeVideoModal() {
        this.isVideoModalOpen = false;
    }
}